import { requestWithoutToken, requestWithToken } from "../utils/apis";
export const loginUser = async (payload) => {
  try {
    const res = await requestWithoutToken(
      "POST",
      "/api/user/signin",
      payload
    );
    return res;
  } catch (error) {
    return error?.response?.data || { status: 0, message: "Login failed" };
  }
};


export const fetchList = async (page, limit, search = "") => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/page/list?page=${page}&limit=${limit}&search=${search}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const deletePage = async (id) => {
  try {
    const response = await requestWithToken("DELETE", `/api/page/${id}`);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const fetchRegionList = async () => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/region/list`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const fetchLanguageList = async () => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/language/list`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const CreateNewPage = async (payload) => {
  try {
    const res = await requestWithoutToken(
      "POST",
      "/api/page",
      payload
    );
    return res;
  } catch (error) {
    return error?.response?.data;
  }
};
export const fetchPageDetail = async (id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/page/details/${id}`
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const AddNewRegion = async (payload) => {
  try {
    const res = await requestWithToken(
      "POST",
      "/api/page/region",
      payload
    );
    return res;
  } catch (error) {
    return error?.response?.data;
  }
};
export const UpdateActiveInactiveStatus = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/api/page/status/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to update settings",
    };
  }
};